import React, { Fragment, useState, useEffect } from "react";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, P } from "../../../AbstractElements";
import {
	EmailAddress,
	ForgotPassword,
	Password,
	RememberPassword,
	SignIn,
} from "../../../Constant";
import { useNavigate } from "react-router-dom";
import { firebase_app, Jwt_token } from "../../../Config/Config";
import { loginProvider } from "../../../Config/Config";
import man from "../../../assets/images/dashboard/1.png";
import { handleResponse } from "../../../Services/fack.backend";
import SocialAuth from "./SocialAuth";
import axios, { AxiosError } from "axios";
import { TopCenter, directiontoaster } from "../../../Constant";
import { toast, ToastContainer } from "react-toastify";
import "../styles.css";

const LoginTab = ({ selected }) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [togglePassword, setTogglePassword] = useState(false);
	const history = useNavigate();
	const [error, setError] = useState("");

	const [value, setValue] = useState(
		sessionStorage.getItem("profileURL" || man)
	);
	const [name, setName] = useState(sessionStorage.getItem("Name"));
	const API_BASE_URL = window.appConfig.API_BASE_URL;

	const logUserIn = async (email) => {
		const result = await axios.get(
			`${API_BASE_URL}/Candidate/GetByEmail?email=${email}`
		);
		sessionStorage.setItem("candidateId", result.data.candidateId);
		sessionStorage.setItem("name", result.data.name);
		sessionStorage.setItem("surname", result.data.surname);
		sessionStorage.setItem("gender", result.data.gender);
		sessionStorage.setItem("jobTitle", result.data.currentJobTitle);
		setTimeout(() => {
			history(`${process.env.PUBLIC_URL}/View-Candidates`);
		}, 200);
	};

	useEffect(() => {
		sessionStorage.setItem("profileURL", value);
		sessionStorage.setItem("Name", name);
	}, [value, name]);

	window.onload = () => {
		sessionStorage.removeItem("token");
	};

	let handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			let res = await axios.post(
				`${API_BASE_URL}/Account/AdminLogin`,
				{
					email: email,
					password: password,
				},
				{ headers: { "Content-Type": "application/json" } }
			);
			const userId = res.data.userId;
			sessionStorage.setItem("userId", userId);
			if (res.status === 200) {
				loginProvider.signIn(email, password);
				setEmail("");
				setPassword("");
				sessionStorage.setItem("email", email);
				sessionStorage.setItem("token", res.data.token);
				logUserIn(email);
			}
		} catch (err) {
			let errorMessge = "Error Occured While Logging In.";
			errorMessge = err?.response?.data?.message ?? errorMessge;
			toast.error(errorMessge, { position: toast.POSITION.TOP_CENTER });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Fragment>
			<Form className="theme-form" onSubmit={handleSubmit}>
				<ToastContainer />
				<H4>Sign In</H4>
				<P>{"Enter your username & password to login"}</P>
				<FormGroup>
					<Label className="col-form-label">Email</Label>
					<Input
						className="form-control"
						type="text"
						required={true}
						onChange={(e) => setEmail(e.target.value)}
						value={email}
						autoComplete="email"
					/>
				</FormGroup>
				<FormGroup className="position-relative">
					<Label className="col-form-label">{Password}</Label>
					<Input
						className="form-control"
						type={togglePassword ? "text" : "password"}
						onChange={(e) => setPassword(e.target.value)}
						value={password}
						required={true}
						autoComplete="current-password"
					/>
					<div
						className="show-hide"
						onClick={() => setTogglePassword(!togglePassword)}
					>
						<span className={togglePassword ? "" : "show"}></span>
					</div>
				</FormGroup>
				<div className="form-group mb-0">
					{/* <div className="checkbox ms-3">
						<Input id="checkbox1" type="checkbox" />
						<Label className="text-muted" for="checkbox1">
							{RememberPassword}
						</Label>
					</div> */}
					{/* <a className="link" href="#javascript">
						{ForgotPassword}
					</a> */}
					<Btn
						attrBtn={{
							color: "primary",
							className: "btn-block",
							disabled: loading ? loading : loading,
						}}
					>
						{loading ? "LOADING..." : SignIn}
					</Btn>
				</div>
			</Form>
		</Fragment>
	);
};
export default LoginTab;
